module.exports = __webpack_public_path__ + "static/media/selectTool.f28eb28a.gif";